import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import { Select } from 'antd';

function Home () {
    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    return(
        // <>
        // {/* <div className='container'><HeroSection /></div> */}
        // <HeroSection />
        // <Cards />
        // {/* <br /> */}
        // {/* <Footer /> */}
        // </>

        // <Select
        //                     className='rounded-md'
        //                     defaultValue="lucy"
        //                     style={{
        //                         width: 120,
        //                     }}
        //                     onChange={handleChange}
        //                     options={[
        //                         {
        //                         value: 'jack',
        //                         label: 'Jack',
        //                         },
        //                         {
        //                         value: 'lucy',
        //                         label: 'Lucy',
        //                         },
        //                         {
        //                         value: 'Yiminghe',
        //                         label: 'yiminghe',
        //                         },
        //                         {
        //                         value: 'disabled',
        //                         label: 'Disabled',
        //                         disabled: true,
        //                         },
        //                     ]}
        //                     />
        <>
            <div className='md:mt-5 phone:mt-[4px]  container bg-white flex flex-col gap-20'>
                <section>
                    <div className='flex flex-col-reverse md:flex-row  relative '>
                        <div className='bg-white px-4 md:py-10 phone:mt-[14px] md:w-[443px] md:absolute rounded-md md:mt-5'>
                            <p className='font-bold section-head-main text-left'>Urban living,<br/> made simple</p>
                            <p className='text-[#214B32] font-medium text-base md:mt-6 md:mb-10 phone:my-[10px]'>Find beautiful coliving spaces for the best prices possible and discover a new way of living that combines convenience, collaboration, and a sense of belonging. </p>
                            <div class="relative">
                                <select class="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                                    <option>Lagos</option>
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                </div>
                            </div>
                            
                            <a className='flex items-center justify-center phone:h-[52px] w-full rounded-xl bg-[#64E296] text-[#214B32] text-center py-4 text-base mt-3' href='/rent-a-home'>Find my home</a>
                        </div>
                        <div className='flex md:justify-between w-full'>
                            <p className='phone:invisible phone:p-0'> </p>
                            <img src='/images/newHomePic.png' className=''/>
                        </div>
                        {/* <img src='/images/newHomePic.png' className=''/> */}
                    </div>
                </section>

                <section className='mt-20 bg-[#FAF4FD] md:px-[85px] md:py-[72px] flex flex-col gap-[72px] md:gap-[104px] rounded-lg phone:mx-[-10px] phone:px-4'>
                    <p className='phone:pt-12 text-center section-head-main'>Experience the ease of shared living </p>
                    <div className='flex flex-col-reverse md:flex-row gap-12'>
                        <img src='/images/homepic2.png'/>
                        <div className='flex flex-col justify-center md:w-[434px] gap-4'>
                            <p className='text-[#439764] font-bold text-2xl md:text-[28px] leading-9'>Carefully selected pocket friendly homes</p>
                            <p className='text-[#214B32] font-normal text-lg md:text-xl'>Enjoy the benefits of a living in a full house while only paying for one room at a good price.</p>
                        </div>
                        
                    </div>
                    <div className='flex flex-col md:flex-row gap-12'>
                        
                        <div className='flex flex-col justify-center md:w-[434px] gap-4'>
                            <p className='text-[#439764] font-bold text-2xl md:text-[28px] leading-9'>Flatmates that absolutely match your vibe.</p>
                            <p className='text-[#214B32] font-normal text-lg md:text-xl'>Choose your ideal flatmates from our curated profiles of residents in the house. Rest easy knowing that every member in our community has been thoroughly vetted for your peace of mind.</p>
                        </div>
                        <img src='/images/homepic3.png'/>
                        
                    </div>
                    <div className='flex flex-col-reverse md:flex-row gap-12'>
                        <img src='/images/homepic4.png'/>
                        <div className='flex flex-col justify-center md:w-[434px] gap-4'>
                            <p className='text-[#439764] font-bold text-2xl md:text-[28px] leading-9'>An experience tailored for your convenience, from house hunting to moving in</p>
                            <p className='text-[#214B32] font-normal text-lg md:text-xl'>Find a home, view it and pay all from the comfort of your phone - move in whenever youre ready too!</p>
                        </div>
                    </div>
                    <p></p>
                </section>

                <section>
                    <p className='text-center section-head-main md:w-[683px] md:mx-auto md:mb-12'>Best in class support, when and where you need it </p>
                    <div className='phone:flex-col md:columns-3'>
                        <div className='flex flex-col relative md:w-[411px]'>
                            <img src='/images/homeapp1.png' className='w-[284px] mx-auto'/>
                            <div className='absolute bottom-0 bg-white text-center pb-12'>
                                <p className='text-[#0B1911] font-bold text-lg text-[21px]'>Pay your rent and all your bills without hassle from one app </p>
                                <p className='text-[#214B32] font-normal text-lg'>Streamline your home payments effortlessly through our home app. Bid farewell to bill-splitting concerns as everyone takes charge of their own payments within the app.</p>
                            </div>
                        </div>
                        <div className='flex flex-col relative md:w-[411px]'>
                            <img src='/images/homeapp2.png' className='w-[284px] mx-auto'/>
                            <div className='absolute bottom-0 bg-white text-center pb-12'>
                                <p className='text-[#0B1911] font-bold text-lg text-[21px]'>Access discounted home services that make your daily life easy</p>
                                <p className='text-[#214B32] font-normal text-lg'>Unlock a handpicked selection of services  tailored to simplify your life, complemented by round-the-clock maintenance and support for your peace of mind.</p>
                            </div>
                        </div>
                        <div className='flex flex-col relative md:w-[411px]'>
                            <img src='/images/homeapp3.png' className='w-[284px] mx-auto'/>
                            <div className='absolute bottom-0 bg-white text-center pb-12'>
                                <p className='text-[#0B1911] font-bold text-lg text-[21px]'>In app chat to connect with you with community and support</p>
                                <p className='text-[#214B32] font-normal text-lg'>Immerse yourself in a vibrant community and experience seamless support from fellow flatmates and bubble through our interactive social features.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className='relative flex w-full justify-center items-center'>
                        <img src='/images/nexthomebg.png' className='phone:h-[479px]'/>
                        <div className='absolute px-4 w-[360px] md:w-[846px] mx-auto bg-white py-14 text-center items-center rounded-lg flex flex-col'>
                            <p className='text-center section-head-main pb-4'>Ready to find your next home?</p>
                            <p className='text-xl font-normal pb-10'>We have homes specially designed for you across your city!</p>
                            <a className='block w-[280px] rounded-xl bg-[#64E296] text-[#214B32] text-center py-4 text-base mt-3' href='/rent-a-home'>Find my home</a>
                        </div>

                    </div>
                </section>
                
            </div>
        </>
    );
    
}

export default Home;